import type { Channel, Coverage, PolicyHolder, Quote } from "@/api_client";

import { getEcommerceAdd } from "./data/ecommerce";
import insuranceInfo from "./data/insuranceInfo";
import objectInfo from "./data/objectInfo";
import productInfo from "./data/productInfo";
import type { AddToCart } from "./types/types";

export const createAddToCart = (
  contextId: string,
  enigmatizedPolicyHolder: PolicyHolder | undefined | null,
  product: Quote,
  enigmatizedProduct: Quote | undefined,
  channel: Channel,
  coverageContent: Record<string, Coverage> | undefined,
): AddToCart | undefined => {
  const event: AddToCart = {
    event: "Add to Cart",
    productInfo: productInfo.getProductInfo(product, channel),
    objectInfo: [
      objectInfo.getObjectInfo(
        enigmatizedPolicyHolder,
        product,
        enigmatizedProduct,
      ),
    ],
    insuranceInfo: insuranceInfo.getInsuranceInfo(
      contextId,
      product,
      coverageContent,
    ),
    ecommerce: getEcommerceAdd(product, channel, coverageContent),
  };

  return event;
};
